import { afterNextRender, DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';

/**
 * Temporary workaround for a CCL gap (aw-component-lib 26.3.0): `aw-table` has no input for an accessible name, and an
 * `aria-label` on the `<aw-table>` host isn't announced (the host has no role). Names the inner `<table>` elements
 * instead (WCAG 1.3.1, 4.1.2). CCL renders a desktop and a mobile table, so the observer catches whichever appears later.
 *
 * Delete this directive once CCL adds an accessible-name input to `aw-table`.
 */
@Directive({
  selector: 'aw-table[appTableName]',
})
export class TableNameDirective {
  /** Accessible name announced for the table. */
  readonly appTableName = input.required<string>();

  constructor() {
    const host: HTMLElement = inject(ElementRef).nativeElement;
    const name = () => {
      host.querySelectorAll('table').forEach((table) => {
        if (table.getAttribute('aria-label') !== this.appTableName()) {
          table.setAttribute('aria-label', this.appTableName());
        }
      });
    };
    const observer = new MutationObserver(name);

    afterNextRender(() => {
      name();
      observer.observe(host, { childList: true, subtree: true });
    });
    inject(DestroyRef).onDestroy(() => observer.disconnect());
  }
}
